import ChallengesLeaderboardPage from './ChallengesLeaderboardPage';

export default ChallengesLeaderboardPage;
